<template>
  <div class="l-page l-page--analysis-group">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <div class="p-breadcrumb p-breadcrumb--analysis-group">
          <ul class="p-breadcrumb-list">
            <li class="p-breadcrumb-list__item">
              <a :href="breadcrumbData[0].url">プロジェクト全体</a>
            </li>
            <li class="p-breadcrumb-list__item">
              <span>{{ group.group_name }}</span>
            </li>
          </ul>
        </div>
        <!-- /パンくずリスト -->
        <date-range-picker
          ref="refCalendarModal"
          :initial-start-date="displayPeriod.from"
          :initial-end-date="displayPeriod.to"
          :on-date-range-changed="onDateRangeChanged"
          cancel-button-label="キャンセル"
          enter-button-label="決定"
        />
      </div>
      <div class="c-tab c-tab--summary-group">
        <ul class="c-tab-list">
          <li class="c-tab-list__item is-active" data-type="summary" @click="() => { onTabClick('summary') }">配信成果</li>
          <li class="c-tab-list__item" data-type="device" @click="() => { onTabClick('device') }">デバイス別</li>
          <li class="c-tab-list__item" data-type="timezone" @click="() => { onTabClick('timezone') }">曜日と時間</li>
          <!-- <li class="c-tab-list__item" data-type="prefecture" @click="() => { onTabClick('prefecture') }">地域</li> -->
          <!-- <li class="c-tab-list__item" data-type="demogra" @click="() => { onTabClick('demogra') }">性別・年齢</li> -->
          <!-- <li class="c-tab-list__item" data-type="interest" @click="() => { onTabClick('interest') }">興味・関心</li> -->
        </ul>
      </div>
      <div class="l-main-content">
        <div class="p-analysis-all-summary is-active">
          <div class="c-title">
            <div class="c-title__text u-fs34">グループでの配信成果</div>
            <div class="c-date u-w352">
              <div class="c-date__title"></div>
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
            <div class="c-proposal u-w210">
              <!-- <div class="c-icon c-icon--blue-2 u-wh22">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#light">
                                </use>
                            </svg>
                        </div>
                        <div class="c-proposal__text u-fs18">AIによる改善案<span class="c-proposal__value">8</span>件</div> -->
            </div>
          </div>
          <div class="p-analysis-all-summary__metrics">
            <div class="p-metrics-summary">
              <ul class="p-metrics-summary-list">
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--impression is-active">
                    <dt class="c-metrics__label">インプレッション</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--click">
                    <dt class="c-metrics__label">クリック数</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--ctr">
                    <dt class="c-metrics__label">クリック率(%)</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>

          <div class="p-analysis-all-summary__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary">
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPath)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPath)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
              </ul>
            </div>
          </div>
          <div>
            <input
              id="is_excluding_ad"
              v-model="isExcludingAd"
              type="checkbox"
              @change="onChangeIsExcludingAd"
            />
            <label for="is_excluding_ad">広告配信を除外</label>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
          <div ref="summaryTable" class="p-analysis-all-summary__data-table" :class="{ 'is-loading': isSummaryTableLoading }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-analysis-all-summary__content p-analysis-all-summary__content--table-static">
              <table class="c-table c-table--static c-table--delivery-message">
                <thead>
                  <tr>
                    <th class="c-table__cell--center u-w100 is-sortable">
                      <span class="c-table__text">配信日時</span>
                      <sort-switch name="sendStartDate" :order="sortTargets.sendStartDate" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center is-sortable">
                      <span class="c-table__text">タイトル・メッセージ</span>
                      <sort-switch name="messageTitle" :order="sortTargets.messageTitle" @on-click="onSortButtonClick($event)" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(summaryTableItem, index) in summaryTableItems" :key="`idx-delivery-message-table-${index}`" class="">
                    <td class="c-table__cell--center c-table__cell--middle" style="white-space: nowrap;">
                      {{ getDisplayDate(summaryTableItem.message.message_deliver.send_start_date) }}
                      {{ getDisplayTime(summaryTableItem.message.message_deliver.send_start_date) }}
                    </td>
                    <td class="c-table__cell--center c-table__cell--middle is-next" @click="onClickDetail(summaryTableItem)">
                      <p class="u-w240 u-text-bold u-text-ellipsis">{{ summaryTableItem.message.message_title }}</p>
                      <p class="u-w240 u-text-ellipsis">{{ summaryTableItem.message.message_text }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="scrollbar" style="width: 530px; height: 15px; overflow-x: scroll; overflow-y: hidden; position: absolute; left: 390px; top: -15px; z-index: 2;">
              <div class="inner" style="height: 1px; width: 1000px;"></div>
            </div>

            <div class="p-analysis-all-summary__content p-analysis-all-summary__content--table-scroll">
              <table class="c-table c-table--scroll c-table--delivery-message">
                <thead>
                  <tr>
                    <th class="c-table__cell--center u-w90 is-sortable">
                      <span class="c-table__text">配信対象数</span>
                      <sort-switch name="distributionCount" :order="sortTargets.distributionCount" @on-click="onSortButtonClick($event)" />
                    </th>
                    <!-- 設計書 §4.3: 配信時アクティブユーザー数 (集計期間はアカウント設定 `account.setting_active_user_days` に従う)
                                         feature gate: sender_id 不在 (R7) または AU 機能 OFF (R7b: days=0) のとき
                                         API 側で active_user_count_at_delivery キーを付与しないため、
                                         activeUserColumnEnabled = false で列を非表示にする -->
                    <th
                      v-show="activeUserColumnEnabled"
                      class="c-table__cell--center u-w110"
                      title="その配信日時点でのアクティブユーザー数"
                    >
                      <span class="c-table__text">配信時 AU</span>
                    </th>
                    <th class="c-table__cell--center u-w96 is-sortable">
                      <span class="c-table__text">インプレッション</span>
                      <sort-switch name="displayCount" :order="sortTargets.displayCount" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w82 is-sortable">
                      <span class="c-table__text">クリック数</span>
                      <sort-switch name="clickCount" :order="sortTargets.clickCount" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w70 is-sortable">
                      <span class="c-table__text">クリック率</span>
                    </th>
                    <th class="c-table__cell--center u-w146 is-sortable">
                      <span class="c-table__text">配信ターゲット</span>
                    </th>
                    <th class="c-table__cell--center u-w100 is-sortable">
                      <span class="c-table__text">集計日</span>
                      <sort-switch name="summaryDate" :order="sortTargets.summaryDate" @on-click="onSortButtonClick($event)" />
                    </th>
                    <th class="c-table__cell--center u-w140 is-sortable">
                      <span class="c-table__text">設定URL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(summaryTableItem, index) in summaryTableItems" :key="`idx-delivery-message-metrics-table-${index}`" class="">
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayNumber(summaryTableItem.distribution_count) }}</td>
                    <!-- 設計書 §4.3: 配信時 AU セル (列非表示時は v-show=false でレンダリングしない) -->
                    <td
                      v-show="activeUserColumnEnabled"
                      class="c-table__cell--center c-table__cell--middle"
                      :title="getActiveUserCellTooltip(summaryTableItem)"
                    >
                      {{ getActiveUserCellText(summaryTableItem) }}
                    </td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayNumber(summaryTableItem.display_count) }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayNumber(summaryTableItem.click_count) }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayRate(summaryTableItem.click_count,summaryTableItem.display_count) }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayCondition(summaryTableItem.message) }}</td>
                    <td class="c-table__cell--center c-table__cell--middle">{{ getDisplayDate(summaryTableItem.summary_date) }}</td>
                    <td class="c-table__cell--center c-table__cell--middle c-table__cell--external-link">
                      <div class="c-text c-text--center">
                        <a :href="summaryTableItem.message.click_url" target="_blank">
                          サイトへリンク
                          <div class="c-icon c-icon--blue-link-1 u-wh16">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <use xlink:href="/assets/img/sprite.svg#external-link" />
                            </svg>
                          </div>
                        </a>
                      </div></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />

            <div v-show="isShowDisplayNumberPerPage" style="position: absolute; bottom: 0; right: 25%;">
              表示件数
              <select v-model="perPage" style="border: solid 1px #ccc; position: relative; border-radius: 5px; padding: 0 10px; height: 38px;" @change="onPerPageChanged()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>

            <!--
                    <div class="p-pagination">
                        <div class="p-pagination-summary">
                            <span class="p-pagination-summary__text">全</span>
                            <span class="p-pagination-summary__value p-pagination-summary__value--total">30</span>
                            <span class="p-pagination-summary__text">件中、</span>
                            <span class="p-pagination-summary__value p-pagination-summary__value--from">1</span>
                            <span class="p-pagination-summary__value p-pagination-summary__value--to">10</span>
                            <span class="p-pagination-summary__text">件を表示しています</span>
                        </div>
                        <ul class="p-pagination-list">
                            <li class="p-pagination-list__item p-pagination-list__item--first">
                                <a href="./message.html"></a>
                            </li>
                            <li class="p-pagination-list__item p-pagination-list__item--prev">
                                <a href="./message.html?page=1"></a>
                            </li>
                            <li class="p-pagination-list__item">
                                <a href="./message.html?page=1">1</a>
                            </li>
                            <li class="p-pagination-list__item is-active">2</li>
                            <li class="p-pagination-list__item">
                                <a href="./message.html?page=3">3</a>
                            </li>
                            <li class="p-pagination-list__item p-pagination-list__item--next">
                                <a href="./message.html?page=3"></a>
                            </li>
                            <li class="p-pagination-list__item p-pagination-list__item--last">
                                <a href="./message.html?page=12"></a>
                            </li>
                        </ul>
                    </div>
                    -->
            <!-- <div class="c-text c-text--download"><a href="#">配信成果でCSVダウンロード</a></div> -->
          </div>
          <div class="p-analysis-all-summary__data-table p-analysis-all-summary__data-table--download">
            <blue-button
              classes="u-w300"
              text="配信成果でCSVダウンロード"
              @click="downloadDeliveryCsv"
            />
          </div>
        </div>
        <div class="p-analysis-device">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">デバイス別での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
          </h2>
          <div class="c-tab c-tab--analysis c-tab--device">
            <div class="c-tab__title">指標</div>
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <h3 class="c-title c-title--group">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」に対しての割合
            </div>
          </h3>
          <div class="p-analysis-device__graph is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-donuts-wrapper">
              <svg class="c-graph-donuts c-graph-donuts--device">
                <g class="c-graph-donuts__chart" />
                <g class="c-graph-donuts__values" />
                <g class="c-graph-donuts__title" />
                <g class="c-graph-donuts__labels" />
              </svg>
              <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--device">
                <ul class="c-tooltip-list">
                  <li class="c-tooltip-list__item c-tooltip-list__item--desktop is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--mobile is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--tablet is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
                </ul>
              </div>
            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」での合計数
            </div>
            <div class="c-text"><a :href="deviceCsvUrl" target="_blank">CSVデータ ダウンロード</a></div>
          </h3>
          <div class="p-analysis-device__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--graph-donuts">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable"><span
                    class="c-table__text"
                  >デバイス</span><span
                    class="c-btn c-btn--sort"
                    data-type="deviceId"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >配信対象数</span><span
                    class="c-btn c-btn--sort c-btn--sort-desc"
                    data-type="delivery"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >インプレッション</span><span
                    class="c-btn c-btn--sort"
                    data-type="impression"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック数</span><span
                    class="c-btn c-btn--sort"
                    data-type="click"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック率(%)</span><span
                    class="c-btn c-btn--sort"
                    data-type="ctr"
                  ></span></th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="p-analysis-timezone">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">曜日と時間での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
          </h2>
          <div class="c-tab c-tab--analysis c-tab--timezone">
            <div class="c-tab__title">指標</div>
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <h3 class="c-title c-title--group">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」に対してのクロス集計
            </div>
          </h3>
          <div class="p-analysis-timezone__heatmap is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-heatmap-timezone">
              <div class="c-graph-heatmap-timezone__row">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">月</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">火</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">水</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">木</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">金</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">土</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">日</div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="0_3">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  0〜3時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-0_3">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="3_6">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  3〜6時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-3_6">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="6_9">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  6〜9時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-6_9">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="9_12">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  9〜12時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-9_12">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="12_15">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  12〜15時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-12_15">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="15_18">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  15〜18時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-15_18">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="18_21">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  18〜21時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-18_21">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="21_0">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  21〜24時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-21_24">
                </div>
              </div>
            </div>
            <ul class="c-graph-heatmap-timezone-bar">
              <li class="c-graph-heatmap-timezone-bar__item"><span></span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r1">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r2">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r3">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r4">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r5">
                <span>-</span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r6">
                <span>-</span></li>
            </ul>
            <ul class="c-graph-heatmap-timezone-bar-label-x">
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
            </ul>

            <div class="c-tooltip c-tooltip--analysis c-tooltip--heatmap-timezone">
              <div class="c-tooltip__title">日曜 午前 3~6</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--label">配信対象</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--metrics">227,700</li>
              </ul>
            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」での合計数
            </div>
            <div class="c-text"><a :href="timezoneCsvUrl" target="_blank">CSVデータ ダウンロード</a></div>
          </h3>
          <div class="p-analysis-timezone__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--heatmap-timezone">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable"><span class="c-table__text">曜日</span><span
                    class="c-btn c-btn--sort"
                    data-type="weekId"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >時間</span><span
                    class="c-btn c-btn--sort"
                    data-type="hourId"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >配信対象数</span><span
                    class="c-btn c-btn--sort c-btn--sort-desc"
                    data-type="delivery"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >インプレッション</span><span
                    class="c-btn c-btn--sort"
                    data-type="impression"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック数</span><span
                    class="c-btn c-btn--sort"
                    data-type="click"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック率(%)</span><span
                    class="c-btn c-btn--sort"
                    data-type="ctr"
                  ></span></th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div
          class="p-analysis-prefecture"
          :class="[{'is-active': activeTab == 'prefecture'}]"
        >
          <h2 class="c-title">
            <div class="c-title__text u-fs34">都道府県別での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
          </h2>

          <!-- 指標選択タブ -->
          <analysis-tab
            :current="state.prefecture.metricsType"
            :on-select="onAnalysisTabClick"
          />

          <h3 class="c-title c-title--group">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」に対しての割合
            </div>
          </h3>

          <!-- 表示（地域別・都道府県別）切り替えタブ -->
          <prefecture-tab
            classes="c-tab--analysis c-tab--prefecture"
            :current="state.prefecture.regionType"
            :on-select="onClickPrefectureTab"
          />

          <!-- ヒートマップ -->
          <div
            class="p-analysis-prefecture__heatmap"
            :class="[{'is-loading': isLoading.prefecture.heatmap}, {'is-empty': isEmpty.prefecture.heatmap}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div
              class="p-analysis-prefecture__item"
              :class="[{'is-active': state.prefecture.regionType == 'region'}]"
            >
              <heatmap-region
                ref="heatmapRegion"
                size="l"
              />
            </div>
            <div
              class="p-analysis-prefecture__item"
              :class="[{'is-active': state.prefecture.regionType == 'prefecture'}]"
            >
              <heatmap-prefecture
                ref="heatmapPrefecture"
                size="l"
              />
            </div>
          </div>

          <!-- 配信結果テーブル -->
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」での合計数
            </div>
            <div class="c-text"><a href="#">CSVデータ ダウンロード</a></div>
          </h3>
          <div
            class="p-analysis-prefecture__data"
            :class="[{'is-loading': isLoading.prefecture.table}, {'is-empty': isEmpty.prefecture.table}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div
              class="p-analysis-prefecture__item"
              :class="[{'is-active': state.prefecture.regionType == 'region'}]"
            >
              <table-region-analysis
                ref="tableRegion"
                classes="c-table--heatmap-prefecture"
                :on-sort-click="onClickPrefectureTableSortBtn"
              />
            </div>
            <div
              class="p-analysis-prefecture__item"
              :class="[{'is-active': state.prefecture.regionType == 'prefecture'}]"
            >
              <table-prefecture-analysis
                ref="tablePrefecture"
                classes="c-table--heatmap-prefecture"
                :on-sort-click="onClickPrefectureTableSortBtn"
              />
            </div>
          </div>
        </div>
        <div class="p-analysis-demogra">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">年齢・性別での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
          </h2>
          <div class="c-tab c-tab--analysis c-tab--demogra">
            <div class="c-tab__title">指標</div>
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <h3 class="c-title c-title--group">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」に対しての割合
            </div>
          </h3>
          <div class="p-analysis-demogra__graph is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="p-analysis-demogra__graph-ratio">
              <div class="c-graph-ratio-gender">
                <div class="c-graph-ratio-gender__label">性別（%）</div>
                <div class="c-graph-ratio-gender-bar">
                  <div class="c-graph-ratio-gender-bar-inner">
                    <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--left">
                    </div>
                    <div class="c-graph-ratio-gender-bar__item c-graph-ratio-gender-bar__item--right">
                    </div>
                  </div>
                </div>
                <div class="c-graph-ratio-gender-value">
                  <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--left">
                  </div>
                  <div class="c-graph-ratio-gender-value__item c-graph-ratio-gender-value__item--right">
                  </div>
                </div>
              </div>
              <div class="c-graph-heatmap-age">
                <div class="c-graph-heatmap-age-bar__label">年齢（歳）</div>
                <ul class="c-graph-heatmap-age-bar">
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="_19"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="20_29"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="30_34"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="35_39"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="40_44"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="45_49"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="50_59"></li>
                  <li class="c-graph-heatmap-age-bar__item" data-age-type="60_"></li>
                </ul>
                <ul class="c-graph-heatmap-age-bar-label-x">
                  <div class="c-graph-heatmap-age-bar-label-x__item">それ以下</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">20</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">30</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">35</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">40</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">45</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">50</div>
                  <div class="c-graph-heatmap-age-bar-label-x__item">それ以上</div>
                </ul>
              </div>

            </div>
            <div class="p-analysis-demogra__graph-bar">
              <svg class="c-graph-stack-chart">
                <!-- クリッピングマスク: 背景フレームと同サイズ -->
                <defs>
                  <clipPath id="clipPath">
                    <rect
                      x="15"
                      y="20"
                      height="200"
                      width="375"
                    />
                  </clipPath>
                </defs>

                <!-- 背景フレーム -->
                <g class="c-graph-stack-chart-frame" clip-path="url(#clipPathStackChart)">
                  <rect
                    class="c-graph-stack-chart-frame__rect"
                    x="15"
                    y="20"
                    height="200"
                    width="375"
                  />
                  <line
                    class="c-graph-stack-chart-frame__line"
                    x1="15"
                    x2="390"
                    y1="220"
                    y2="220"
                  />
                </g>

                <!-- X.Y軸罫線 -->
                <g class="c-graph-stack-chart-bg" clip-path="url(#clipPathStackChart)">
                  <g class="c-graph-stack-chart-bg__x" />
                  <g class="c-graph-stack-chart-bg__y" />
                </g>

                <!-- X.Y軸メモリ -->
                <g class="c-graph-stack-chart-axis">
                  <g class="c-graph-stack-chart-axis__x" />
                  <g class="c-graph-stack-chart-axis__y--left" />
                </g>

                <!-- 積み上げグラフタイトル -->
                <g class="c-graph-stack-chart-label">
                  <text
                    class="c-graph-stack-chart-label__text"
                    opacity="1"
                    y="0"
                    x="-25"
                    text-anchor="start"
                  >年齢別での比較</text>
                </g>

                <!-- 積み上げグラフバー用ラベル -->
                <g class="c-graph-stack-chart-bar-label" />

                <!-- 積み上げグラフバー -->
                <g class="c-graph-stack-chart-bar" clip-path="url(#clipPathStackChart)" />

                <!-- 積み上げグラフバー区切り線 -->
                <g class="c-graph-stack-chart-bar-line" clip-path="url(#clipPathStackChart)" />
              </svg>

              <div class="c-tooltip c-tooltip--graph-line">
                <div class="c-tooltip__title">-</div>
                <ul class="c-tooltip-list">
                  <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
                </ul>
              </div>

            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">
              グループ「<div class="c-text c-text--ellipsis f-w-auto">{{ group.group_name }}</div>」での合計数
            </div>
            <div class="c-text"><a href="#">CSVデータ ダウンロード</a></div>
          </h3>
          <div class="p-analysis-demogra__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--stack-chart-age">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w130 is-sortable"><span
                    class="c-table__text"
                  >性別</span><span
                    class="c-btn c-btn--sort"
                    data-type="genderId"
                  ></span></th>
                  <th class="c-table__cell--center is-sortable"><span class="c-table__text">年齢</span><span
                    class="c-btn c-btn--sort"
                    data-type="ageId"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >配信対象数</span><span
                    class="c-btn c-btn--sort c-btn--sort-desc"
                    data-type="delivery"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >インプレッション</span><span
                    class="c-btn c-btn--sort"
                    data-type="impression"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック数</span><span
                    class="c-btn c-btn--sort"
                    data-type="click"
                  ></span></th>
                  <th class="c-table__cell--center u-w160 is-sortable"><span
                    class="c-table__text"
                  >クリック率(%)</span><span
                    class="c-btn c-btn--sort"
                    data-type="ctr"
                  ></span></th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="p-analysis-interest">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">興味関心での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ startDateString }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ endDateString }}</li>
              </ul>
            </div>
          </h2>
          <div class="c-tab c-tab--analysis c-tab--interest">
            <div class="c-tab__title">指標</div>
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <div class="p-analysis-interest__graph p-analysis-interest__graph--treemap is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-treemap" xmlns="http://www.w3.org/2000/svg" />
            <div class="c-tooltip c-tooltip--analysis c-tooltip--treemap">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--label">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--metrics">-</li>
              </ul>
            </div>
          </div>
          <h3 class="c-title">
            <div class="c-title__text u-fs--l">キーワード</div>
          </h3>
          <div class="p-analysis-interest__graph p-analysis-interest__graph--wordcloud is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-wordcloud" xmlns="http://www.w3.org/2000/svg" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  props: {
    breadcrumbData: Array,
    group: Object,
    displayPeriod: Object,
  },

  data () {
    return {
      from: new Date(this.displayPeriod.from),
      to: new Date(this.displayPeriod.to),
      updateAnalysis: null,
      isSummaryTableLoading: true,
      summaryTableItems: [],
      paginationInfo: null,
      page: 1,
      sortTargets: {
        sendStartDate: -1,
        summaryDate: 0,
        messageTitle: 0,
      },

      // 追加 (* 地域タブ用
      activeTab: 'summary',
      isLoading: {
        prefecture: {
          heatmap: true,
          table: true,
        }
      },
      isEmpty: {
        prefecture: {
          heatmap: false,
          table: false,
        }
      },
      state: {
        prefecture: {
          metricsType: 'delivery',
          regionType: 'region',
        }
      },
      data: {
        prefecture: null,
      },
      sort: {
        prefecture: {
          key: 'delivery',
          type: 'desc',
        }
      },
      isShowDisplayNumberPerPage: false,
      perPage: 10,
      isExcludingAd: false
    }
  },

  computed: {
    startDateString: function() {
      let dateString = '-';
      if(this.from){
        dateString = moment(this.from).format('YYYY/MM/DD');
      }
      return dateString;
    },
    endDateString: function() {
      let dateString = '-';
      if(this.to){
        dateString = moment(this.to).format('YYYY/MM/DD');
      }
      return dateString;
    },
    period: function() {
      let period = {
        from: moment(this.from).format('YYYY-MM-DD'),
        to: moment(this.to).format('YYYY-MM-DD'),
      };
      return period;
    },
    deviceCsvUrl: function() {
      let url = '/api/analysis/summary-device/csv?' +
        'from=' + this.period.from + '&to=' + this.period.to + '&group_id=' + this.group.group_id;
      return url;
    },
    timezoneCsvUrl: function() {
      let url = '/api/analysis/summary-timezone/csv?' +
        'from=' + this.period.from + '&to=' + this.period.to + '&group_id=' + this.group.group_id;
      return url;
    },
    /**
     * 設計書 §4.3 / R7 + R7b feature gate: 配信時 AU 列の表示可否.
     *
     * 全行に `active_user_count_at_delivery` キーが無い場合は
     * (a) sender_id 不在 (R7) または (b) AU 機能 OFF (R7b: account.setting_active_user_days = 0)
     * のいずれかと判定し列自体を非表示にする (API 側でキー未付与のため).
     * 画面ラベルに集計期間 (N 日) は表示しない — 期間はアカウント設定に従う運用ルール.
     */
    activeUserColumnEnabled: function() {
      if (!Array.isArray(this.summaryTableItems) || this.summaryTableItems.length === 0) {
        return false;
      }
      return this.summaryTableItems.some(r =>
        Object.prototype.hasOwnProperty.call(r, 'active_user_count_at_delivery')
      );
    },
  },

  mounted: function() {
    const self = this;
    const period = this.displayPeriod;
    const groupId = this.group.group_id;
    import('../../funcs/pages/analysis-group-summary').then(module => {
      self.updateAnalysis = module.AnalysisGroupSummary();
      self.updateAnalysis(period, groupId, this.isExcludingAd);
      self.updateSummaryMessageDelivery(period,groupId);
    });

    window.addEventListener('scroll', this.onScroll);
  },

  methods: {
    onDateRangeChanged: function(range){
      this.from = range.start;
      this.to= range.end;
      this.page = 1;
      if(this.updateAnalysis){
        this.updateAnalysis(this.period, this.group.group_id, this.isExcludingAd);
        this.updateSummaryMessageDelivery(this.period,this.group.group_id);
      }
    },
    getDisplayDate: function(dateString){
      // 2021-11-29 -> 11/29
      return dateString.substring(5, 10).replace("-","/");
    },
    getDisplayTime: function(dateString){
      // 2021-11-29 20:42:13 -> 20:42
      return dateString.substring(11, 16);
    },
    getDisplayCondition: function(message){
      let conditionString;
      if (message.has_custom_list) {
        conditionString = 'カスタムリスト配信';
      } else if ((message.message_conditions_count == 0) && (message.topic_message_condition_count == 0)){
        conditionString = '全配信';
      } else {
        conditionString = 'セグメント配信';
      }
      return conditionString;
    },
    /**
     * 配信が「全配信 (全体配信)」かどうか判定する.
     * カスタムリスト配信 / セグメント配信 は false.
     */
    isAllDelivery: function(message) {
      if (!message) return false;
      if (message.has_custom_list) return false;
      if (message.message_conditions_count > 0) return false;
      if (message.topic_message_condition_count > 0) return false;
      return true;
    },
    getDisplayNumber: function(numString) {
      return parseInt(numString).toLocaleString();
    },
    /**
     * 設計書 §4.3: 配信時 AU セルの表示テキスト.
     * 全配信のみ数値を表示し、セグメント配信 / カスタムリスト配信は "—" を返す.
     * 値が null (集計未到達) も "—" を返す.
     */
    getActiveUserCellText: function(item) {
      if (!item || !this.isAllDelivery(item.message)) {
        return '—';
      }
      const v = item.active_user_count_at_delivery;
      if (v === null || v === undefined) {
        return '—';
      }
      return parseInt(v).toLocaleString();
    },
    /**
     * 設計書 §4.3: 配信時 AU セルの tooltip.
     * 全配信以外は対象外を、集計未到達のときは集計待ちを示す.
     */
    getActiveUserCellTooltip: function(item) {
      if (!item || !this.isAllDelivery(item.message)) {
        return '全配信以外は AU の対象外';
      }
      const v = item.active_user_count_at_delivery;
      if (v === null || v === undefined) {
        return 'この配信日は AU 集計未到達';
      }
      return '';
    },
    getDisplayRate: function(clickCount,displayCount) {
      let ctrString = '0.00%';
      if(displayCount > 0 && clickCount > 0){
        let ctr = clickCount * 100 / displayCount;
        ctrString = ctr.toFixed(2) + '%';
      }
      return ctrString;
    },
    updateSummaryMessageDelivery: function(period,groupId) {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }
      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
          from: period.from,
          to: period.to,
          group_id: groupId,
          per_page: this.perPage,
          is_excluding_ad: this.isExcludingAd,
        }
      };
      this.isSummaryTableLoading = true;

      // 指標テーブルデータの取得処理実行
      axios.get(`/api/analysis/summary-message/delivery`,params)
        .then(res => {
          this.summaryTableItems = res.data.items.data;
          this.paginationInfo = res.data.items;
          this.isSummaryTableLoading = false;
          this.isShowDisplayNumberPerPage = (res.data.items.per_page < res.data.items.total) ? true : false;
        })
        .catch(e => {
          console.log(e);
          this.isSummaryTableLoading = false;
        });
    },
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.updateSummaryMessageDelivery(this.period,this.group.group_id);
    },
    onSortButtonClick: function(target) {
      event.preventDefault();

      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.updateSummaryMessageDelivery(this.period,this.group.group_id);
    },

    // クリック: 配信成果タイプの切り替えタブ
    onTabClick: function(selected) {
      this.activeTab = selected;

      // 配信成果タイプ選択タブ選択: 地域
      if (this.activeTab == 'prefecture') {
        this.updatePrefectureDataset();
      }
    },

    // クリック: 指標切り替えタブ
    onAnalysisTabClick: function(selected) {
      // 指標タブ選択: 地域
      if (this.activeTab == 'prefecture') {
        this.state.prefecture.metricsType = selected;
        this.updatePrefectureDataset();
      }
    },

    // データ取得処理: 地域別
    updatePrefectureDataset: function() {
      this.isLoading.prefecture.heatmap = true;
      this.isLoading.prefecture.table = true;

      // 送信パラメーター作成
      const params = {
        from: moment(this.from).format('YYYY-MM-DD'),
        to: moment(this.to).format('YYYY-MM-DD'),
        group_id: this.group.group_id,
      };

      // ヒートマップ用データの取得処理実行
      axios.get(`/api/analysis/summary-prefecture/${this.state.prefecture.metricsType}`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // 取得データをキャッシュ
        this.data.prefecture = res.data;

        // 地域別ヒートマップ、ランキングテーブルを更新
        this.$refs.heatmapRegion.init(res.data, this.state.prefecture.metricsType, params)
        this.$refs.tableRegion.init(res.data, params, {
          key: this.state.prefecture.metricsType,
          type: 'desc'
        }
        )

        // 都道府県別ヒートマップ、ランキングテーブルを更新
        this.$refs.heatmapPrefecture.init(res.data, this.state.prefecture.metricsType, params)
        this.$refs.tablePrefecture.init(res.data, params, {
          key: this.state.prefecture.metricsType,
          type: 'desc'
        }
        )

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoading.prefecture.heatmap = false;
          this.isLoading.prefecture.table = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '都道府県別での傾向データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoading.prefecture.heatmap = false;
            this.isLoading.prefecture.table = false;
          }, 300)
        });
    },

    // 表示件数変更
    onPerPageChanged: function() {

      this.updateSummaryMessageDelivery(this.period,this.group.group_id);
    },

    // 横スクロールバーを上部にも表示
    onScroll: function() {
      const targetClasses = ['p-analysis-all-summary__content--table-scroll', 'scrollbar'];
      for(const targetClass of targetClasses) {
        document.querySelector(`.${targetClass}`).addEventListener('scroll', function () {
          const otherClass = this.className.includes(targetClasses[0]) ? targetClasses[1] : targetClasses[0];
          const left = document.querySelector(`.${targetClass}`).scrollLeft;
          document.querySelector(`.${otherClass}`).scrollTo(left, 0);
        })
      }
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 都道府県タブをクリックした時
    onClickPrefectureTab: function(selected) {
      this.state.prefecture.regionType = selected
    },

    // クリック: テーブルソートボタン
    onClickPrefectureTableSortBtn: function(sort) {
      // 送信パラメーター作成
      const params = {
        from: moment(this.from).format('YYYY-MM-DD'),
        to: moment(this.to).format('YYYY-MM-DD'),
        group_id: this.group.group_id,
      };

      // ソート状態を更新
      this.sort.prefecture = {
        key: sort.key,
        type: sort.type,
      };

      // ローダー表示設定
      this.isLoading.prefecture.table = true;

      // テーブルデータの更新
      this.$refs.tableRegion.init(this.data.prefecture, params, {
        key: this.sort.prefecture.key,
        type: this.sort.prefecture.type,
      }
      )
      this.$refs.tablePrefecture.init(this.data.prefecture, params, {
        key: this.sort.prefecture.key,
        type: this.sort.prefecture.type,
      }
      )

      // ローダー非表示設定
      setTimeout(() => {
        this.isLoading.prefecture.table = false;
      }, 300)
    },
    onClickDetail: function(summaryTableItem) {
      let summaryDate = summaryTableItem.summary_date;
      let messageId = summaryTableItem.message.message_id;
      let url = `/coins-admin/analysis/delivery-message/${messageId}/${summaryDate}/${this.period.from}/${this.period.to}`;
      location.href = url;
    },
    downloadDeliveryCsv: function() {
      let url = '/api/analysis/summary-message/delivery/csv?' +
        'from=' + this.period.from + '&to=' + this.period.to + '&group_id=' + this.group.group_id + '&is_excluding_ad=' + this.isExcludingAd;
      location.href = url;
    },

    // クリック： 広告配信を除外
    onChangeIsExcludingAd: function() {
      this.updateSummaryMessageDelivery(this.period, this.group.group_id);
      this.updateAnalysis(this.period, this.group.group_id, this.isExcludingAd);
    },
  }
}
</script>
